export const API_CONSTS = {
  RETRY_QUEUE: "retryQueue",
};
